// ================================================================
// Dummy Nodes — فقط برای نمایش در picker
// ================================================================
// اینها فعلاً فقط آیکون و نام دارن — وقتی روشون کلیک می‌شه چیزی نمی‌سازه.
// در آینده اگه خواستی واقعی بشن، یه فولدر در src/nodes/ بساز و schema بنویس.

const emptySchema = { fields: [] };

function dummy(type, name, subtitle, icon, color, gradient, category = 'allApps', iconColor = 'white') {
  return {
    type,
    nameKey: `nodes.${type}.name`,
    subtitleKey: `nodes.${type}.subtitle`,
    modalTitleKey: `nodes.${type}.title`,
    icon,
    color,
    colorGradient: gradient,
    iconColor,
    category,
    dummy: true,  // وقتی روش کلیک می‌شه، فقط alert می‌ده "هنوز پیاده‌سازی نشده"
    schema: emptySchema
  };
}

export const dummyDefinitions = [
  // All apps
  dummy('googleSheets', 'Google Sheets', 'Spreadsheets', 'table_chart', '#0F9D58', 'linear-gradient(135deg, #34A853, #0F9D58)', 'allApps'),
  dummy('openai',       'OpenAI',         'ChatGPT, Sora', 'auto_awesome',   '#10A37F', 'linear-gradient(135deg, #1AB394, #10A37F)', 'allApps'),
  dummy('airtable',     'Airtable',       'Database',       'table',          '#2563EB', 'linear-gradient(135deg, #3B82F6, #2563EB)', 'allApps'),

  // Built-in tools
  dummy('http',        'HTTP',          'Make request',    'language',     '#475569', 'linear-gradient(135deg, #64748B, #475569)', 'builtIn'),
  dummy('webhooks',    'Webhooks',      'Listen & trigger','webhook',      '#0891B2', 'linear-gradient(135deg, #06B6D4, #0891B2)', 'builtIn'),
  dummy('flowControl', 'Flow Control',  'Router & filter', 'settings',     '#16A34A', 'linear-gradient(135deg, #22C55E, #16A34A)', 'builtIn'),
  dummy('tools',       'Tools',         'Utilities',       'build',        '#1A73E8', 'linear-gradient(135deg, #4F94ED, #1A73E8)', 'builtIn')
];
